import React from "react";
import { Logout } from "../../_helper/constant/auth";
import { useNavigate } from "react-router-dom";

const SomethingWentWrong = ({ errorMessage }) => {
    const navigate = useNavigate();
    const blackColorStyle = { backgroundColor: "var( --black-color)" };
    const handleLogout = () => {
        Logout();
        navigate("/login");
    };
    return (
        <div className="w-screen h-screen flex flex-col justify-center items-center">
            <div className="w-[143.18px] h-[124px]">
                <img
                    className="w-full h-full"
                    src="https://cufront-assets.s3.amazonaws.com/images/somethingWentWrong.png"
                    alt=".."
                />
            </div>
            <div className="my-5 text-center w-[645px]">
                <div className="text-[32px] helvetica my-6 font-bold">
                    Something Went Wrong.
                </div>
                <div className="text-[32px] helvetica text-[#999999] my-6 leading-[36.8px]">
                    We’re sorry. We’re having some trouble completing your
                    request. Please try again.
                </div>
                <div className="text-[28px] helvetica my-6 font-bold">
                    Error: {errorMessage}
                </div>
                <div className="flex items-center gap-3 justify-center">
                    <button
                        className="text-white rounded-[5px] h-11 w-[156px] y-5"
                        onClick={() => navigate(-1)}
                        style={blackColorStyle}>
                        Go back
                    </button>
                    <button
                        className="text-white rounded-[5px] h-11 w-[156px] y-5"
                        onClick={handleLogout}
                        style={blackColorStyle}>
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SomethingWentWrong;
